<template>
    <v-layout row wrap class="symptoms-questions-content symptoms-questions-pro">

        <v-flex :class="{'panel-highlighted': (isNavRelatedSymptomsAvailable && shortcutNav.isPanelHighlight)}" xs12 sm4 md3 lg2 class="related-symptoms component-bg-color">
            <related-symptoms ref="relatedSymptomsRef"
                              @emitRelatedSymptomClick="onRelatedSymptomClick"
                              @emitRelatedSymptomsPanelClick="onRelatedSymptomsPanelClick"
                              @emitNoOtherSymptomsPanelClick="onNoOtherSymptomsPanelClick"
                              :shortcutNav="shortcutNav">
            </related-symptoms>
        </v-flex>

        <v-flex xs12 sm8 md9 lg10 class="selected-symptoms">
            <v-container fluid style="padding-top: 2px;" class="padding-right-xs">
                <v-layout row wrap>
                    <v-flex xs12 md8 lg9 class="no-padding-top">
                        <symptoms-panels ref="symptomsPanelsRef"
                                         @emitChangeAnswer="onChangeAnswer"
                                         @emitQuestionClick="onQuestionClick"
                                         @emitSymptomPanelClick="onSymptomPanelClick"
                                         :shortcutNav="shortcutNav"></symptoms-panels>
                    </v-flex>
                    <v-flex xs12 md4 lg3 class="shared-questions no-padding-top">
                        <v-card id="SHARED_QUESTIONS"
                                class="component-bg-color"
                                :class="{'panel-highlighted': (shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'SHARED_QUESTIONS')}"
                                @click.native="onSharedQuestionsPanelClick">
                            <v-card-text class="px-0">
                                <shared-questions ref="sharedQuestionsRef"
                                                  @emitChangeAnswer="onChangeAnswer"
                                                  @emitQuestionClick="onQuestionClick"
                                                  :shortcutNav="shortcutNav"></shared-questions>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-flex>

    </v-layout>
</template>

<!-- ################################################################## -->

<script>
    import RelatedSymptoms from "../RelatedSymptoms";
    import SharedQuestions from "./SharedQuestions";
    import SymptomsPanels from "./SymptomsPanels";
    import {mapGetters} from "vuex";

    export default {

        name: 'SymptomsQuestionsContent',

        components: {
            RelatedSymptoms,
            SharedQuestions,
            SymptomsPanels
        },

        props: ["shortcutNav"],

        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            isNavRelatedSymptomsAvailable() {
                return this.shortcutNav != null && this.shortcutNav.isKeyboardNav === true && this.shortcutNav.crtPanel === 'RELATED_SYMPTOMS';
            }
        },

        methods: {

            onChangeAnswer(data) {
                this.$emit('emitChangeAnswer', data);
            },

            onQuestionClick(data) {
                this.$emit('emitQuestionClick', data);
            },

            onRelatedSymptomClick(data) {
                this.$emit('emitRelatedSymptomClick', data);
            },

            onRelatedSymptomsPanelClick() {
                this.$emit('emitRelatedSymptomsPanelClick');
            },

            onNoOtherSymptomsPanelClick() {
                this.$emit('emitNoOtherSymptomsPanelClick');
            },

            onSymptomPanelClick(data) {
                this.$emit('emitSymptomPanelClick', data);
            },

            onSharedQuestionsPanelClick() {
                this.$emit('emitSharedQuestionsPanelClick');
            }

        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-panels/SymptomsQuestionsContent.vue